import Vue from "vue";

export default Vue.extend({
    name: "DownloadJsonToCsv",
    computed: {
        CsvHeaders() {
            if(this.data.length < 1)
            {
                return []
            }
            return Object.keys(this.data[0])
        },
        CsvString(){
            var csvString =   this.CsvHeaders.join(',') + '\n';
            this.data.forEach(function(row) {
                let values = Object.values(row)
                
                values.forEach((val:any) => {
                    // encode the value with quotes if it contains a comma
                    if( val?.toString().includes(",")){
                        csvString += `"${val}",`;
                    }else{
                        csvString += `${val},`;
                    }
                })
                csvString += "\n";
            });
        
            return csvString;
        },
        CsvHrefDataString(){
            const startingText = 'data:text/csv;charset=utf-8,'
            // changed to encodeURIComponent so the csv can include # in the data - PAS-3505
            const csvHrefDataString =  startingText + encodeURIComponent(this.CsvString);
            return csvHrefDataString;  
        }
    },
    props: {
        fileName: {
            type: String,
            default: "download.csv"
        },
        data: {
            type: Array,
            default: []
        }
    },
    methods: {
        DownloadCsv(){
            // For IE10+ : (does not support 'a[download]')
            if (navigator.msSaveBlob) {
                var blob = new Blob([this.CsvString],{
                    type:'text/csv;charset=utf-8;'
                });
                
                navigator.msSaveBlob(blob, this.fileName);
                return;
            }
            // For Browsers that don't suck
            this.$refs.hiddenAnchorTag.click();

        }
    }
});
